import { env } from '@/env';
import * as Sentry from '@sentry/react';

/**
 * Initialize Sentry. Call once before rendering the app.
 * No-op when VITE_SENTRY_DSN is not set (e.g. local dev).
 */
export function initSentry(): void {
  if (!env.VITE_SENTRY_DSN) {
    return;
  }

  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    enabled:
      import.meta.env.MODE === 'production' || import.meta.env.MODE === 'test',
  });
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
